import { useMutation } from "@tanstack/react-query";
import { t } from "i18next";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { UsageGuide } from "../../productUsageGuides.types";
import { requestCreateUsageGuideFaqItem } from "./createUsageGuideFaqItem.request";
import { CreateUsageGuideFaqItemRequestBody } from "./createUsageGuideFaqItem.types";

const useCreateUsageGuideFaqItem = (
  options?: MutationOptions<
    UsageGuide,
    ApiServiceError<ApiError>,
    CreateUsageGuideFaqItemRequestBody
  >
) => {
  const refetchUsageGuides = useRefetchQuery(["product-usage-guides"]);

  return useMutation({
    mutationFn: requestCreateUsageGuideFaqItem,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchUsageGuides();
      toast.success(t("Question created successfully"));
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useCreateUsageGuideFaqItem;
